import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "@capacit-com/lara-law-shared-ui";
import { RowData } from "@tanstack/react-table";
import { CustomColumnDef } from "./types/custom-column-def";

interface DataTableSkeletonBaseProps<TData extends RowData> {
  columns: CustomColumnDef<TData>[];
  SkeletonRow: React.ComponentType<{
    columns: CustomColumnDef<TData>[];
  }>;
  rowCount?: number;
}

export function DataTableSkeletonBase<TData extends RowData>({
  columns,
  SkeletonRow,
  rowCount = 5,
}: DataTableSkeletonBaseProps<TData>) {
  return (
    <div className="flex flex-col h-full w-full space-y-6">
      <div className="flex flex-col grow overflow-hidden">
        <div className="grow flex flex-col min-h-0 rounded-md">
          <Table>
            <TableHeader>
              <TableRow>
                {columns.map((column, index) => (
                  <TableHead key={index}>
                    {typeof column.header === "string"
                      ? column.header
                      : typeof column.header === "function"
                        ? column.meta?.displayName
                        : ""}
                  </TableHead>
                ))}
              </TableRow>
            </TableHeader>
            <TableBody>
              {Array.from({ length: rowCount }).map((_, index) => (
                <SkeletonRow key={index} columns={columns} />
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
}
